module.exports = __webpack_public_path__ + "media/images/views/tech_client/benefit-2-09842f21c233a99a1453773302170611.png";